var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('##/##/####'),expression:"'##/##/####'"}],ref:"input",attrs:{"value":_vm.formattedValue,"label":_vm.label,"prepend-icon":_vm.icon,"rules":[function (v) { return this$1.validateDate(v) || 'Invalid date.'; }]},on:{"input":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }